var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-img-list-item",on:{"click":_vm.updateActivePlan}},[_c('ImageWithDesc',{class:{ 'is-active': _vm.checked },attrs:{"data":_vm.planName,"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }